"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _defaultTheme = _interopRequireDefault(require("@material-ui/core/styles/defaultTheme"));

var _styles = require("@material-ui/core/styles");

var _toolkit = require("@ui-propulsion/toolkit");

var _root;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var lendingFonts = {
  fontFamilyMedium: "'Neue Haas Grotesk Text Medium', 'Helvetica Neue', helvetica, arial, sans-serif",
  fontFamilyRegular: "'Neue Haas Grotesk Text Regular', 'Helvetica Neue', helvetica, arial, sans-serif",
  fontFamilyBold: "'Neue Haas Grotesk Text Bold', 'Helvetica Neue', helvetica, arial, sans-serif",
  fontFamilyDisplayBold: "'Neue Haas Grotesk Display Bold', 'Helvetica Neue', helvetica, arial, sans-serif"
};
var pxToRem = _defaultTheme.default.typography.pxToRem;

var _default = (0, _styles.createTheme)({
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1024,
      lg: 1280,
      xl: 1440
    }
  },
  palette: _objectSpread(_objectSpread({}, _toolkit.lendingClubPalette), {}, {
    error: {
      main: _toolkit.lendingClubPalette.cardinal[500]
    },
    warning: {
      light: '#fefaf1',
      main: '#eeb41e'
    },
    text: {
      disabled: _toolkit.lendingClubPalette.stainless[700]
    },
    divider: _toolkit.lendingClubPalette.neutral.stainless
  }),
  props: {
    MuiButtonBase: {
      disableRipple: true,
      disableTouchRipple: true,
      focusRipple: false
    }
  },
  shape: {
    borderRadius: 0
  },
  typography: _objectSpread(_objectSpread({}, lendingFonts), {}, {
    fontFamily: lendingFonts.fontFamilyRegular,
    hero: {
      fontFamily: lendingFonts.fontFamilyDisplayBold,
      fontSize: 32,
      lineHeight: '36px',
      '@media (min-width: 768px)': {
        fontSize: 36,
        lineHeight: '40px'
      },
      '@media (min-width: 1024px)': {
        fontSize: 48,
        lineHeight: '52px'
      }
    },
    title1: {
      fontFamily: lendingFonts.fontFamilyDisplayBold,
      fontSize: 24,
      lineHeight: '28px',
      '@media (min-width: 768px)': {
        fontSize: 28,
        lineHeight: '32px'
      },
      '@media (min-width: 1024px)': {
        fontSize: 36,
        lineHeight: '40px'
      }
    },
    title2: {
      fontFamily: lendingFonts.fontFamilyDisplayBold,
      fontSize: 18,
      lineHeight: '22px',
      '@media (min-width: 768px)': {
        fontSize: 20,
        lineHeight: '24px'
      },
      '@media (min-width: 1024px)': {
        fontSize: 24,
        lineHeight: '28px'
      }
    },
    sectionLabel: {
      fontFamily: lendingFonts.fontFamilyBold,
      fontWeight: 'bold',
      fontSize: 12,
      letterSpacing: 1,
      lineHeight: '16px',
      textTransform: 'uppercase',
      '@media (min-width: 768px)': {
        fontSize: 14,
        lineHeight: '20px'
      },
      '@media (min-width: 1024px)': {
        fontSize: 16,
        lineHeight: '24px'
      }
    },
    body: {
      fontFamily: lendingFonts.fontFamilyRegular,
      fontSize: 16,
      lineHeight: '24px',
      '@media (min-width: 768px)': {
        fontSize: 16,
        lineHeight: '24px'
      },
      '@media (min-width: 1024px)': {
        fontSize: 18,
        lineHeight: '28px'
      }
    },
    small: {
      fontFamily: lendingFonts.fontFamilyRegular,
      fontSize: 14,
      lineHeight: '20px',
      '@media (min-width: 768px)': {
        fontSize: 14,
        lineHeight: '20px'
      },
      '@media (min-width: 1024px)': {
        fontSize: 16,
        lineHeight: '24px'
      }
    },
    micro: {
      fontFamily: lendingFonts.fontFamilyRegular,
      fontSize: 12,
      lineHeight: '16px',
      '@media (min-width: 768px)': {
        fontSize: 12,
        lineHeight: '16px'
      },
      '@media (min-width: 1024px)': {
        fontSize: 14,
        lineHeight: '20px'
      }
    },
    button: {
      fontFamily: lendingFonts.fontFamilyMedium,
      fontSize: pxToRem(16),
      textTransform: 'none'
    }
  }),
  overrides: {
    MuiFormHelperText: {
      root: (_root = {
        color: _toolkit.lendingClubPalette.neutral.narwhal,
        fontSize: pxToRem(14),
        fontFamily: lendingFonts.fontFamilyRegular,
        lineHeight: '20px',
        opacity: 0,
        transition: 'opacity 0.15s',
        '&$disabled': {
          color: _toolkit.lendingClubPalette.stainless[700]
        },
        '&.Mui-focused': {
          opacity: 1
        }
      }, (0, _defineProperty2.default)(_root, ['&.Mui-warning', '&.Mui-error'], {
        opacity: 1
      }), (0, _defineProperty2.default)(_root, '@media (min-width: 1024px)', {
        fontSize: pxToRem(16),
        lineHeight: '24px'
      }), _root)
    },
    MuiInputAdornment: {
      root: {
        color: _toolkit.lendingClubPalette.denim[500],
        fontFamily: lendingFonts.fontFamilyMedium
      }
    },
    MuiInputBase: {
      root: {
        color: _toolkit.lendingClubPalette.denim[500]
      }
    }
  }
});

exports.default = _default;
